import React, { useEffect, useState } from "react";
import CreateVisaButton from "./CreateVisaButton";
import { getVisaRequirements } from "../../../../controllers/visaController";
import CommonPaginationSection from "../../../../components/common/CommonPaginationSection";
import { templateTransitVisaData } from "../../../../data/order/customerTransitVisaTable";
import VisaList from "./VisaList";
import NoVisas from "./NoVisas";
import { URLdecode } from "../../../../utils/url";
import { useLocation, useNavigate } from "react-router-dom";

function Visa() {
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    page: 1,
    perPage: 10,
    total: 10,
  });
  const [orders, setOrders] = useState([]);
  const [ogData, setOgData] = useState([]);
  const params = URLdecode();
  const navigate = useNavigate();
  const location = useLocation();

  const loadData = async () => {
    if (params?.deleted) {
      navigate(location.pathname, { replace: true });
      return;
    }
    const [total, tableData, data] = await getVisaRequirements({
      pagination,
      setLoading,
    });
    setPagination({ ...pagination, total });
    setOrders(tableData);
    setOgData(data);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    loadData();
  }, [pagination.page, pagination.perPage, params?.deleted]);
  return (
    <div className="w-full flex flex-col">
      <div className="w-full items-center justify-between flex">
        <h5>Transit Visa</h5>
        <CreateVisaButton />
      </div>
      {loading ? (
        <div className="w-full flex flex-col py-4 items-center justify-center">
          <div className="primaryLoader"></div>
        </div>
      ) : (
        <>
          {orders.length === 0 ? (
            <NoVisas />
          ) : (
            <>
              <VisaList
                loading={loading}
                ogData={ogData}
                orders={orders}
                callback={(updatedVisa) => {
                  const updatedVisasData = ogData.map((data) =>
                    data._id === updatedVisa?._id
                      ? updatedVisa?.detail?._id
                        ? updatedVisa
                        : { ...updatedVisa, detail: data?.detail }
                      : data
                  );
                  const [updatedOrders, updatedData] = [
                    updatedVisasData.map((item) =>
                      templateTransitVisaData(item)
                    ),
                    updatedVisasData,
                  ];
                  setOrders(updatedOrders);
                  setOgData(updatedData);
                }}
              />
              <CommonPaginationSection
                perPage={pagination.perPage}
                page={pagination.page}
                total={pagination.total}
                callback={(page, perPage) =>
                  setPagination({ ...pagination, page, perPage })
                }
              />
            </>
          )}
        </>
      )}
    </div>
  );
}

export default Visa;
